var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDarkbrownSuccessCheckmark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_198",
    "data-name": "Group 198",
    transform: "translate(-144 -408)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_66",
    "data-name": "Path 66",
    d: "M86.077,109.96a4.5,4.5,0,0,1-2.771-.943L53.534,85.2c-1.887-1.533-2.393-3.39-.86-5.276s3.589-1.533,5.475,0l27.928,22.326,40.189-45.836c1.592-1.828,2.966-1.592,4.794,0s1.592,2.521,0,4.348L89.379,108.486A4.425,4.425,0,0,1,86.077,109.96Z",
    transform: "translate(111.943 388.456)",
    fill: "#6B2900"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_17",
    "data-name": "Ellipse 17",
    transform: "translate(144 408)",
    fill: "none",
    stroke: "#6B2900",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 60,
    r: 60,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 60,
    r: 58.5,
    fill: "none"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDarkbrownSuccessCheckmark);
export default __webpack_public_path__ + "static/media/darkbrown-success-checkmark.16f657b922d378f07887f0d79dc2f9d0.svg";
export { ForwardRef as ReactComponent };